import React from 'react';
import PropTypes from 'prop-types';

import TabMui from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabListMui from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

const Tab = (props) => {
  const {
    sx,
    ...tabProps
  } = props;

  return (
    <TabMui
      {...tabProps}
      sx={{
        'minWidth': 'fit-content',
        'p': 0,
        'color': '#A8A49E',
        'fontSize': '13px',
        'fontWeight': 400,
        'lineHeight': '17px',
        'textTransform': 'none',
        '&.Mui-selected': {
          color: '#1A1916',
        },
        ...sx,
      }}
    />
  );
};
Tab.propTypes = {
  sx: PropTypes.object,
};

const TabList = (props) => {
  const {
    sx,
    ...tabListProps
  } = props;

  return (
    <TabListMui
      {...tabListProps}
      sx={{
        'minHeight': '37px',
        'px': '16px',
        'borderBottom': '1px solid',
        'borderColor': '#E8E4DE',
        '& .MuiTabs-scroller': {
          overflowX: 'auto !important',
        },
        '& .MuiTabs-flexContainer': {
          gap: '32px',
          alignItems: 'center',
        },
        '& .MuiTabs-indicator': {
          height: '2px',
          borderRadius: '1px 1px 0 0',
          backgroundColor: '#1A1916',
        },
        '& .MuiTabs-scrollButtons': {
          maxWidth: '10px',
        },
        ...sx,
      }}
    />
  );
};
TabList.propTypes = {
  sx: PropTypes.object,
};

export {
  Tab, TabContext, TabList, TabPanel,
};
